<markant-button
  colorScheme="primary"
  variant="clear"
  [attr.id]="'audit-button'"
  [routerLink]="[LINK]"
>
  <markant-icon slot="icon-leading" icon="m_history"></markant-icon>
  <div>{{ 'audit.title' | transloco }}</div>
</markant-button>
